import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Spin, Tabs, Tag } from 'antd'
import Amount from '../../../../components/Common/Amount'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import ReceiptsCont from '../../../../components/Sales/Payments/Receipts/ReceiptsCont'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useTitle from '../../../../elements/Hooks/useTitle'
import IconText from '../../../../elements/IconText'
import OverrideActionButton from '../../../../elements/OverrideActionButton'
import Status from '../../../../elements/Status'
import Authentication from '../../../../modules/Authentication'
import { boolVal, dateVal, idMaker, numVal, strVal } from '../../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { streamUrl } from '../../../../variables/index'
import History from '../../../Common/History'
import style from '../style.css'
import InvoiceModal from './InvoiceModal'
import BillLineModal from './Tabs/Details/BillLines/BillLineModal'
import Details from './Tabs/Details/Details'
import EmailListCont from '../../../Main/Emails/EmailCont'

const { TabPane } = Tabs
const auth = new Authentication()
const ids = idMaker()

function ViewInvoice(props) {
  const {
    invoice,
    fetch,
    fetching,
    handleOps,
    actions,
    visibleEmail,
    emailDetails,
    emailFiles,
    emailLines,
    emailTemplate,
    onCancelEmail,
    showEmail,
  } = props
  useTitle(`${invoice.code} Invoice`)

  const { data: centers } = useFetchURL(`foxxapi/centers?select=_id,name,_parent`)
  const isUpdatable = actions.find((a) => a.key === 'update') && true
  const isClosed = ['Closed'].includes(invoice.status)
  const isConfirmed = ['Confirmed', 'Paid'].includes(invoice.status)
  const isOverrideable = ['Confirmed', 'Paid', 'Part Paid', 'Draft', 'Submitted', 'Revised'].includes(invoice.status)
  const within7Days = moment().diff(dateVal(invoice, 'date'), 'days') + 1 < 7
  const requiresOverride = !within7Days || (['Part Paid'].includes(invoice.status))
  const isRequestFunds = invoice.type === 'Funds Request'

  const Operations = ({ invoice, ...rest }) => {
    const ops = actions.map((a) => (
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to ${a.value}?`}
          onConfirm={() => handleOps(a.key, invoice)}
          okText="Yes"
          cancelText="No">
          <a>{a.value}</a>
        </Popconfirm>
      </span>
    ))
    if (!isClosed) {
      ops.push(
        <a
          target={'_blank'}
          href={`${streamUrl}pdf/${invoice._id}${
            isRequestFunds ? '/fundsRequest' : ''
          }?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
      ops.push(
        <a onClick={showEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <FooterButtons style={{ float: 'right', marginBottom: 10 }} update={() => handleOps('update')} title={'Voucher'} />
  )

  return (
    <Spin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/invoices/">Invoices</Breadcrumb.Item>
            <Breadcrumb.Item>{invoice.code}</Breadcrumb.Item>
          </Breadcrumb>
          <Col span={15}>
            <div className={style.title}>
              <h2 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                {strVal(invoice, 'code').trim()}
                <Tag style={{ marginLeft: '5px' }} color={boolVal(invoice, 'taxFiled') ? 'green' : 'red'}>
                  {boolVal(invoice, 'taxFiled') ? 'TAX Filed' : 'TAX Not Filed'}
                </Tag>
                <Tag style={{ marginLeft: '5px' }} color={boolVal(invoice, 'posted') ? 'blue' : 'red'}>
                  {boolVal(invoice, 'posted') ? 'Posted' : 'Not Posted'}
                </Tag>
              </h2>
              <h3 className={'icon-text-header'}>{strVal(invoice, 'title').trim()}</h3>
              <Status style={{ float: 'right' }} value={strVal(invoice, 'status')} />
              <Operations style={{ marginTop: '10px' }} invoice={invoice} status={strVal(invoice, 'status')} />
              {isOverrideable && requiresOverride && (
                <OverrideActionButton
                  {...{
                    fetch,
                    doc: invoice._id,
                    company: strVal(invoice, 'company._id'),
                    override: strVal(invoice, 'override'),
                  }}
                />
              )}
            </div>
          </Col>
          <Col span={7}>
            <Amount
              data={[
                { name: 'SUB-TOTAL', amount: numVal(invoice, 'subTotal.net') },
                { name: 'TAX', amount: numVal(invoice, 'subTotal.tax') },
                { name: 'TOTAL', amount: numVal(invoice, 'subTotal.gross') },
              ]}
              currency={invoice.currency}
            />
          </Col>
          <RefreshButton onClick={fetch} />
        </Row>
      </Card>
      <InvoiceModal {...{ ...props, centers }} />
      <Row style={{ paddingTop: '10px' }}>
        <Card style={{ minHeight: '542px' }}>
          <EmailCont
            key={ids.next().value}
            visible={visibleEmail}
            onCancel={onCancelEmail}
            template={emailTemplate}
            email={emailDetails}
            files={emailFiles}
            lines={emailLines}
          />
          <Row style={{ paddingTop: '10px' }}>
            <BillLineModal isUpdatable={isUpdatable} {...props} />
            <Tabs defaultActiveKey="dashboard">
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Details
                  </span>
                }
                key="dashboard">
                {isConfirmed && (
                  <Row>
                    <SubmitButton />
                  </Row>
                )}
                <Details isUpdatable={isUpdatable} {...{ ...props, centers }} />
                {isConfirmed && (
                  <Row>
                    <SubmitButton />
                  </Row>
                )}
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="copy" />
                    History
                  </span>
                }
                key="history">
                <History loading={fetching} owner={invoice} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="file-text" />
                    Receipts
                  </span>
                }
                key="receipts">
                <ReceiptsCont invoice={invoice} />
              </TabPane>
              <TabPane tab="Email" key="email">
                <EmailListCont owner={invoice._id} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="folder-open" />
                    Documents
                  </span>
                }
                key="documents">
                <Documents editable={true} email={true} owner={invoice} />
              </TabPane>
            </Tabs>
          </Row>
        </Card>
      </Row>
    </Spin>
  )
}

ViewInvoice.propTypes = {}
ViewInvoice.defaultProps = {}

export default ViewInvoice
